import { all, fork, put, takeEvery, call, takeLatest } from "redux-saga/effects";
import { delay } from "redux-saga";
import MsModal from "src/components/ms-common/ms-modal/MsModal";
import { ERROR_MESSAGE } from "src/common/constants";
import { PayActionTypes } from "./types";
import { 
  fetchPayList,
  fetchPayListFinish,
  fetchLoading,
  fetchPayBatch,
  fetchTempUrl,
  fetchOnePayFinish,
  fetchCommon,
  fetchDownLoadTemp,
  fetchApplyPay,
  fetchStatusList,
  fetchStatusListFinish,
  fetchQueryImage,
  fetchExportExcel,
  fetchExportByTaskId,
  fetchExportByTaskIdFinish
} from "./actions";
import { fetchApi, fetchFileApi } from "src/utils/fetchApi";
import Tools from "src/utils/tools";

// 查询发放列表
function* handleFetchPay(action: ReturnType<typeof fetchPayList>) {
  try {
    yield put(fetchLoading({showA: true, text: "正在查询，请稍后..."}));
    const res = yield call(fetchApi, "post", "salaryCpayCp/payroll/list", action.payload);
    if (res) {
      let { records } = res.data;
      records = records.map((ele: any) => {
        const { checkTotalNum, succCheckNum, failCheckNum, totalNum, succNum, failNum } = ele;
        ele.authResult = {
          checkTotalNum,
          succCheckNum,
          failCheckNum
        }
        ele.payResult = {
          totalNum,
          succNum,
          failNum
        }
        return ele;
      });
    }
    yield put(fetchPayListFinish({
      payList: res ? res.data.records : [],
      pagination: {
        pageSize: res ? res.data.pageSize : 10,
        current: res ? res.data.pageIndex : 1,
        total: res ? res.data.totalCount : 0
      }
    }));
    const dom = document.getElementsByClassName("ant-table-body");
    if (dom && dom[0]) {
      dom[0].scrollTop = 0;
    } 
  } catch (err) {
    MsModal.error({content: err instanceof Error ? err.stack! : ERROR_MESSAGE});
  }
  yield put(fetchLoading({showA: false, text: ""}));
}

// 获取批次号
function* handleFetchBatch(action: ReturnType<typeof fetchPayBatch>) {
  try {
    const res = yield call(fetchApi, "get", "salaryCpayCp/income/getGenerateIdentityCode");
    yield put(fetchOnePayFinish({batchNo: res ? res.data : ""}));
  } catch(err) {
    MsModal.error({content: err instanceof Error ? err.stack! : ERROR_MESSAGE});
  }
}

// 查询是否有名单模板
function* handleFetchTempUrl(action: ReturnType<typeof fetchTempUrl>) {
  try {
    const p = Tools.appendParams("salaryCpayCp/income/getTemplateUrl", action.payload);
    const res = yield call(fetchApi, "get", p, action.payload);
    if (res) {
      const arr = res.data.split(",");
      yield put(fetchOnePayFinish({
        tempUrl: arr[0],
        fileName: arr[1],
        tempFields: arr[2]
      }));
      yield put(fetchOnePayFinish({isShowNew: true})); // 进入创建发放页面
      yield put(fetchPayBatch()); // 获取批次号
    } else {
      yield put(fetchOnePayFinish({
        tempUrl: "",
        fileName: "",
        tempFields: ""
      }));
    }
  } catch(err) {
    MsModal.error({content: err instanceof Error ? err.stack! : ERROR_MESSAGE});
  }
}

// 下载模板文件
function* handleDownloadTemp(action: ReturnType<typeof fetchDownLoadTemp>) {
  try {
    const p = Tools.appendParams("salaryCpayCp/income/downloadTemplate", action.payload.data);
    const res = yield call(fetchFileApi, "get", p);
	  if (res) {
      "msSaveOrOpenBlob" in window.navigator
      ? window.navigator.msSaveOrOpenBlob(res, action.payload.fileName)
      : Tools.downloadFile(window.URL.createObjectURL(res), action.payload.fileName);
    }
	} catch(err) {
    MsModal.error({content: err instanceof Error ? err.stack! : ERROR_MESSAGE});
  }
}

// 确认发放、撤销发放、保存凭证
function* handleCommon(action: ReturnType<typeof fetchCommon>) {
  try {
    const type = action.payload.type;
    let str = "";
    let url = "salaryCpayCp/payroll/";
    switch (type) {
      case "confirm": {
        str = "提交发放";
        url += type;
        break;
      }
      case "cancel": {
        str = "撤销发放";
        url += type;
        break;
      }
      case "upload": {
        str = "保存凭证";
        url = "salaryCpayCp/voucher/save";
        break;
      }
    }
    yield put(fetchLoading({showB: true, text: `正在${str}，请稍后...`}));
    const res = yield call(fetchApi, "post", url, action.payload.data);
    if (res) {
      yield put(fetchLoading({showB: false, text: ""}));
      yield successPromise(`${str}成功`);
      yield put(fetchOnePayFinish({isShowModal: false}));
      yield put(fetchPayList(action.payload.searchParams));
    }
  } catch(err) {
    MsModal.error({content: err instanceof Error ? err.stack! : ERROR_MESSAGE});
  }
  yield put(fetchLoading({showB: false, text: ""}));
}

// 返回无内容，为了同步执行下一个方法
function successPromise(str: any) {
  return new Promise((resolve) => {
    MsModal.success({
      content: str,
      onOk: () => {
        resolve();
      }
    })
  })
}

// 创建发放
function* handleApply(action: ReturnType<typeof fetchApplyPay>) {
  try {
    const str = action.payload.type === "apply" ? "创建发放" : "调整名单";
    yield put(fetchLoading({showB: true, text: `正在${str}，请稍后...`}));
    const res = yield call(fetchApi, "post", "salaryCpayCp/income/saveSalaryApplyDetail", action.payload.data);
    if (res) {
      yield put(fetchLoading({showB: false, text: ""}));
      yield successPromise(`${str}成功`);
      yield put(fetchOnePayFinish({isShowNew: false, isShowModal: false}));
      yield put(fetchPayList(action.payload.searchParams));
    }
  } catch(err) {
    MsModal.error({content: err instanceof Error ? err.stack! : ERROR_MESSAGE});
  }
  yield put(fetchLoading({showB: false, text: ""}));
}

// 查询状态下拉列表
function* handleStatusList(action: ReturnType<typeof fetchStatusList>) {
  try {
    const p = Tools.appendParams("salaryCpayCp/systemParameter/salaryStatus", action.payload);
    const res = yield call(fetchApi, "get", p);
    yield put(fetchStatusListFinish(res ? res.data.records : []));
  } catch(err) {
    MsModal.error({content: err instanceof Error ? err.stack! : ERROR_MESSAGE});
  }
}

// 查看凭证
function* handleQueryImage(action: ReturnType<typeof fetchQueryImage>) {
  try {
    const p = Tools.appendParams("salaryCpayCp/voucher/look", action.payload);
    const res = yield call(fetchApi, "get", p);
    yield put(fetchOnePayFinish({imageList: res ? res.data.records : []}))
  } catch(err) {
    MsModal.error({content: err instanceof Error ? err.stack! : ERROR_MESSAGE});
  }
}

// 导出获取taskId
function* handleGetTaskId(action: ReturnType<typeof fetchExportExcel>) {
  try {
    yield put(fetchLoading({showA: true, text: "正在准备导出，请稍后..."}));
    const res = yield call(fetchApi, "post", "salaryCpayCp/exportTask/payrollListExport", action.payload);
    if (res) {
      yield put(fetchExportByTaskId({...res.data, fileName: action.payload.fileName}));
    }
  } catch (err) {
    MsModal.error({content: err instanceof Error ? err.stack! : ERROR_MESSAGE});
  }
  yield put(fetchLoading({showA: false, text: ""}));
}

// 执行导出
function* handleGetExportRate(action: ReturnType<typeof fetchExportByTaskId>) {
  const param: any = action.payload;
  try {
    if (param.stopDownload) { // 点"取消"时传的参数, 停止执行
      yield put(fetchExportByTaskIdFinish({showRate: false, rate: 0}));
    } else {
      const newParam: any = {
        ...action.payload,
        fileName: encodeURI(encodeURI(action.payload.fileName))
      }
      const p = Tools.appendParams("salaryCpayCp/exportTask/downloadExcel", newParam);
      const res = yield call(fetchApi, "get", p);
      if (res) {
        if (res.data.rate < 100) {
          yield delay(300);
          yield put(fetchExportByTaskIdFinish({showRate: true, rate: res.data.rate}));
          yield put(fetchExportByTaskId(action.payload));
        } else {
          yield put(fetchExportByTaskIdFinish({showRate: true, rate: res.data.rate}));
          yield delay(1000);
          yield put(fetchExportByTaskIdFinish({showRate: false, rate: 0}));
          yield Tools.downloadFile(res.data.downloadPath, "");
        }
      } else {
        yield put(fetchExportByTaskIdFinish({showRate: false, rate: 0}));
      }
    }
  } catch (err) {
    yield put(fetchExportByTaskIdFinish({showRate: false, rate: 0}));
    MsModal.error({content: err instanceof Error ? err.stack! : ERROR_MESSAGE});
  }
}

// 监控，根据指定action类型，调用saga方法
function* watchFetchPay() {
  yield takeEvery(PayActionTypes.FETCH_QUERY_PAY_LIST, handleFetchPay);
  yield takeEvery(PayActionTypes.FETCH_QUERY_BATCH, handleFetchBatch);
  yield takeEvery(PayActionTypes.FETCH_QUERY_TEMP_URL, handleFetchTempUrl);
  yield takeEvery(PayActionTypes.FETCH_DOWNLOAD_TEMP, handleDownloadTemp);
  yield takeEvery(PayActionTypes.FETCH_COMMON, handleCommon);
  yield takeEvery(PayActionTypes.FETCH_APPLY_PAY, handleApply);
  yield takeEvery(PayActionTypes.FETCH_STATUS_LIST, handleStatusList);
  yield takeEvery(PayActionTypes.FETCH_QUERY_IMAGE, handleQueryImage);
  yield takeEvery(PayActionTypes.FETCH_EXPORT_EXCEL, handleGetTaskId);
  yield takeLatest(PayActionTypes.FETCH_EXPORT_BY_TASKID, handleGetExportRate);
}

// 合并所有saga监控
function* paySaga() {
  yield all([
    fork(watchFetchPay)
  ]);
}

export default paySaga;



// WEBPACK FOOTER //
// ./src/store/pay/sagas.ts